import React from "react";
import "./SpecializedCategories.css";

const SpecializedCategories = ({ categories = [], title = "Specialized Categories", compact = false }) => {
  const groups = categories.reduce((result, category) => {
    const key = category.parentPublicId || category.parentLabel || "specialized";
    if (!result[key]) {
      result[key] = {
        label: category.parentLabel || title,
        categories: []
      };
    }
    result[key].categories.push(category);
    return result;
  }, {});

  if (!categories.length) return null;

  return (
    <section className={`specialized-categories ${compact ? "compact" : ""}`}>
      {title && <h4>{title}</h4>}
      <div className="specialized-category-groups">
        {Object.entries(groups).map(([key, group]) => (
          <div className="specialized-category-group" key={key}>
            <strong>{group.label}</strong>
            <ul>
              {group.categories.map((category) => (
                <li key={category.publicId || category.id}>{category.label}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SpecializedCategories;
